module.exports = __webpack_public_path__ + "static/media/replay.743edff3.svg";